export type JsonSearchMode = 'filter' | 'highlight';
export const DEFAULT_SEARCH_MODE: JsonSearchMode = 'highlight';
